import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@afosto/app-components-react/Icon';
import styled from 'styled-components';

const SuccessIcon = styled(Icon)`
  && {
    color: ${props => props.theme.palette.success.main};
  }
`;

const ParcelStatusIcon = ({ parcel }) => (
  <>
    {parcel?.is_finished && <SuccessIcon icon={['fal', 'box-check']} />}
    {parcel?.is_in_transit && !parcel?.is_finished && (
      <Icon icon={['fal', 'shipping-fast']} color="primary" />
    )}
    {!parcel?.is_finished && !parcel?.is_in_transit && <Icon icon={['fal', 'dolly']} />}
  </>
);

ParcelStatusIcon.propTypes = {
  parcel: PropTypes.object,
};

ParcelStatusIcon.defaultProps = {
  parcel: undefined,
};

export default ParcelStatusIcon;
